import React, { useState, useEffect } from 'react';
import './atom.css';
import CircularProgress from '@mui/material/CircularProgress';
import Modal from 'react-modal';
import { getAuditLogChangeView } from '../services/master.service';
import * as CryptoJS from "crypto-js";

Modal.setAppElement('#root');

const AuditLogChangeView = ({ isLogId, isVersion, isOpen, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState({});

  useEffect(() => {
    const getTransferInfo = async function (log_id) {
      setLoading(true);
      try {
        let EncryptData = CryptoJS.AES.encrypt(
          JSON.stringify({
            'param_data': { 'log_id': log_id },
            'authToken': sessionStorage.getItem('LoggedInToken'),
          }),
          process.env.REACT_APP_ENCRYPT_SECRET_KEY
        ).toString();
        let oData1 = { 'token': EncryptData };

        const res = await getAuditLogChangeView(oData1);
        if (res?.data?.data?.length) {
          setItems(res.data.data[0]);
        } else {
          setItems({});
        }
      } catch (error) {
        console.error("Error fetching audit log change view info:", error);
      } finally {
        setLoading(false);
      }
    };

    if (isLogId && isOpen) {
      getTransferInfo(isLogId);
    }
  }, [isLogId, isOpen]);

  // Parse old and new values safely
  const parseJSON = (input) => {
    if (!input) return {};
    let parsed = input;
    if (typeof parsed === 'string') {
      try {
        parsed = JSON.parse(parsed);
      } catch (e) {
        return {};
      }
    }
    if (typeof parsed === 'string') {
      try {
        parsed = JSON.parse(parsed);
      } catch (e) {
        // keep as is
      }
    }
    return typeof parsed === 'object' && parsed !== null ? parsed : {};
  };

  const olddataObject = parseJSON(items.old_values);
  const newdataObject = parseJSON(items.new_values);

  // Filter out internal fields if needed
  const filterKeys = ['company_id'];
  const olddataArray = Object.entries(olddataObject).filter(([key]) => !filterKeys.includes(key));
  const newdataArray = Object.entries(newdataObject).filter(([key]) => !filterKeys.includes(key));

  // Build a set of all unique keys between old and new
  const allKeys = Array.from(new Set([...Object.keys(olddataObject), ...Object.keys(newdataObject)]))
    .filter(key => !filterKeys.includes(key));

  const formatTimestamp = (dateStr) => {
    if (!dateStr || dateStr === '—') return '—';
    try {
      const dte = new Date(dateStr);
      if (isNaN(dte.getTime())) return dateStr;
      const year = dte.getFullYear();
      const month = String(dte.getMonth() + 1).padStart(2, '0');
      const day = String(dte.getDate()).padStart(2, '0');
      const hours = String(dte.getHours()).padStart(2, '0');
      const minutes = String(dte.getMinutes()).padStart(2, '0');
      const seconds = String(dte.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    } catch (e) {
      return dateStr;
    }
  };

  const formatKeyName = (key) => {
    if (!key) return '';
    if (key === 'division_id') return 'Division';
    if (key === 'created_by') return 'Created By';
    if (key === 'updated_by') return 'Updated By';
    if (key === 'ownership_id' || key === 'ownership_department' || key === 'department_id') return 'Ownership Department';
    if (key === 'created_at') return 'Created At';
    if (key === 'updated_at') return 'Updated At';
    return key
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const formatVal = (key, val) => {
    if (val === undefined || val === null || val === '') return '—';
    const str = String(val);
    if (key === 'created_at' || key === 'updated_at' || /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(str)) {
      return formatTimestamp(str);
    }
    return str;
  };

  const prevVersionNum = isVersion && isVersion > 1 ? isVersion - 1 : 0;
  const eventStr = String(items.event || '').toLowerCase();
  const isCreatedActivity = eventStr.includes('create') || eventStr.includes('addition') || eventStr.includes('insert') || (isVersion === 1 && (!items.old_values || items.old_values === '{}' || Object.keys(olddataObject).length === 0));

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Differences Log Version"
      style={customModalStyles}
      className="audit-log-change-modal-content"
      overlayClassName="audit-log-change-modal-overlay"
    >
      <style>{`
        .ReactModal__Overlay.audit-log-change-modal-overlay {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          position: fixed !important;
          top: 0 !important;
          left: 0 !important;
          right: 0 !important;
          bottom: 0 !important;
          background-color: rgba(15, 23, 42, 0.65) !important;
          backdrop-filter: blur(6px) !important;
          z-index: 1300 !important;
          padding: 16px !important;
        }

        .ReactModal__Content.audit-log-change-modal-content {
          position: relative !important;
          top: auto !important;
          left: auto !important;
          right: auto !important;
          bottom: auto !important;
          inset: auto !important;
          margin: 0 auto !important;
          width: 1180px !important;
          max-width: 95vw !important;
          max-height: 88vh !important;
          padding: 0 !important;
          border: 1px solid rgba(226, 232, 240, 0.8) !important;
          border-radius: 16px !important;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.35) !important;
          overflow: hidden !important;
          background: #ffffff !important;
        }
      `}</style>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          maxHeight: '85vh',
          background: '#ffffff',
          borderRadius: '16px',
          overflow: 'hidden',
          fontFamily: 'inherit'
        }}
      >
        {/* Modal Header */}
        <div
          style={{
            background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
            padding: '16px 24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            color: '#ffffff',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'

          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div
              style={{
                width: '36px',
                height: '36px',
                borderRadius: '8px',
                background: 'rgba(56, 189, 248, 0.15)',
                border: '1px solid rgba(56, 189, 248, 0.3)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#38bdf8',
                fontSize: '18px'
              }}
            >
              <i className="bi bi-file-earmark-diff-fill"></i>
            </div>
            <div>
              <h5 style={{ margin: 0, fontWeight: 700, fontSize: '18px', color: '#ffffff' }}>
                Differences Log Version
              </h5>
              <p style={{ margin: '2px 0 0 0', fontSize: '12px', color: '#94a3b8' }}>
                Audit comparison of asset property changes
              </p>
            </div>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <span
              style={{
                background: 'rgba(255, 255, 255, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                color: '#f8fafc',
                padding: '4px 12px',
                borderRadius: '20px',
                fontSize: '12px',
                fontWeight: 600
              }}
            >
              Version {isVersion || 1}
            </span>
            <button
              onClick={onClose}
              style={{
                background: 'rgba(255, 255, 255, 0.1)',
                border: 'none',
                color: '#cbd5e1',
                width: '32px',
                height: '32px',
                borderRadius: '50%',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '18px',
                transition: 'all 0.2s ease'
              }}
              onMouseOver={(e) => { e.currentTarget.style.background = 'rgba(255, 255, 255, 0.25)'; e.currentTarget.style.color = '#ffffff'; }}
              onMouseOut={(e) => { e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)'; e.currentTarget.style.color = '#cbd5e1'; }}
            >
              &times;
            </button>
          </div>
        </div>

        {/* Info Sub-Header Bar */}
        <div
          style={{
            background: '#f8fafc',
            borderBottom: '1px solid #e2e8f0',
            padding: '12px 24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            fontSize: '13px',
            color: '#334155'
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontWeight: 600 }}>
            <span
              style={{
                background: isCreatedActivity ? '#131915ff' : '#e0f2fe',
                color: isCreatedActivity ? '#15803d' : '#0369a1',
                padding: '3px 10px',
                borderRadius: '12px',
                fontSize: '12px',
                fontWeight: 600,
                textTransform: 'capitalize'
              }}
            >
              Activity: {items.event ? items.event.toUpperCase() : 'UPDATED'}
            </span>
            <span>
              Comparing <strong>Version {prevVersionNum}</strong> &rarr; <strong>Version {isVersion || 1}</strong>
            </span>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '16px', color: '#475569', fontWeight: 500 }}>
            {(items.updated_at || items.created_at) && (
              <span style={{ fontSize: '12px', background: '#f1f5f9', color: '#334155', padding: '3px 10px', borderRadius: '12px', border: '1px solid #cbd5e1' }}>
                <i className="bi bi-clock-history me-1 text-primary"></i>
                Timestamp: <strong>{formatTimestamp(items.updated_at || items.created_at)}</strong>
              </span>
            )}
            <div>
              <i className="bi bi-person-fill text-primary me-1"></i>
              <span>Performed by: <strong>{items.user_name || 'System User'}</strong></span>
            </div>
          </div>
        </div>

        {/* Modal Body */}
        <div style={{ flex: 1, padding: '20px 24px', overflowY: 'auto' }}>
          {loading ? (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '60px 0' }}>
              <CircularProgress size={36} style={{ color: '#0284c7' }} />
              <p style={{ marginTop: '12px', color: '#64748b', fontSize: '14px', fontWeight: 500 }}>
                Loading change details...
              </p>
            </div>
          ) : (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
              {/* Previous Version Column */}
              <div
                style={{
                  background: '#ffffff',
                  borderRadius: '12px',
                  border: '1px solid #e2e8f0',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.02)',
                  overflow: 'hidden'
                }}
              >
                <div
                  style={{
                    background: '#f1f5f9',
                    borderBottom: '1px solid #e2e8f0',
                    padding: '12px 16px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                  }}
                >
                  <span style={{ fontWeight: 700, color: '#334155', fontSize: '14px' }}>
                    <i className="bi bi-clock-history me-2 text-secondary"></i>
                    Previous State (v{prevVersionNum})
                  </span>
                  <span style={{ fontSize: '11px', background: '#cbd5e1', color: '#1e293b', padding: '2px 8px', borderRadius: '10px', fontWeight: 600 }}>
                    Old Values
                  </span>
                </div>

                <div style={{ padding: '0' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                    <thead>
                      <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                        <th style={{ padding: '10px 14px', textAlign: 'left', color: '#475569', fontWeight: 600, width: '35%', backgroundColor: '#d1def2' }}>
                          Particulars
                        </th>
                        <th style={{ padding: '10px 14px', textAlign: 'left', color: '#475569', fontWeight: 600, width: '65%', backgroundColor: '#d1def2' }}>
                          Value
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {allKeys.length > 0 ? (
                        allKeys.map((key) => {
                          const rawOld = olddataObject[key] !== undefined && olddataObject[key] !== null ? olddataObject[key] : '—';
                          const rawNew = newdataObject[key] !== undefined && newdataObject[key] !== null ? newdataObject[key] : '—';
                          const oldVal = formatVal(key, rawOld);
                          const isChanged = !isCreatedActivity && String(rawOld) !== String(rawNew);

                          return (
                            <tr
                              key={key}
                              style={{
                                borderBottom: '1px solid #f1f5f9',
                                background: isChanged ? '#fef2f2' : 'transparent',
                                transition: 'background 0.15s ease'
                              }}
                            >
                              <td style={{ padding: '9px 14px', fontWeight: 600, color: isChanged ? '#991b1b' : '#334155' }}>
                                {formatKeyName(key)}
                              </td>
                              <td style={{ padding: '9px 14px', color: isChanged ? '#991b1b' : '#475569', fontWeight: isChanged ? 600 : 400 }}>
                                {oldVal}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="2" style={{ padding: '24px', textAlign: 'center', color: '#94a3b8' }}>
                            No previous version record data available.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Updated Version Column */}
              <div
                style={{
                  background: '#ffffff',
                  borderRadius: '12px',
                  border: isCreatedActivity ? '1px solid #bbf7d0' : '1px solid #bae6fd',
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.03)',
                  overflow: 'hidden'
                }}
              >
                <div
                  style={{
                    background: isCreatedActivity
                      ? 'linear-gradient(180deg, #f0fdf4 0%, #dcfce7 100%)'
                      : 'linear-gradient(180deg, #f0f9ff 0%, #e0f2fe 100%)',
                    borderBottom: isCreatedActivity ? '1px solid #bbf7d0' : '1px solid #bae6fd',
                    padding: '12px 16px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                  }}
                >
                  <span style={{ fontWeight: 700, color: isCreatedActivity ? '#15803d' : '#0369a1', fontSize: '14px' }}>
                    <i className={`bi ${isCreatedActivity ? 'bi-plus-circle-fill text-success' : 'bi-check-circle-fill text-primary'} me-2`}></i>
                    Updated State (v{isVersion || 1})
                  </span>
                  <span style={{ fontSize: '11px', background: isCreatedActivity ? '#16a34a' : '#0284c7', color: '#ffffff', padding: '2px 8px', borderRadius: '10px', fontWeight: 600 }}>
                    {isCreatedActivity ? 'Created Values' : 'New Values'}
                  </span>
                </div>

                <div style={{ padding: '0' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                    <thead>
                      <tr style={{ background: isCreatedActivity ? '#f0fdf4' : '#f0f9ff', borderBottom: isCreatedActivity ? '1px solid #bbf7d0' : '1px solid #bae6fd' }}>
                        <th style={{ padding: '10px 14px', textAlign: 'left', color: isCreatedActivity ? '#15803d' : '#0369a1', fontWeight: 600, width: '35%', backgroundColor: '#d1def2' }}>
                          Particulars
                        </th>
                        <th style={{ padding: '10px 14px', textAlign: 'left', color: isCreatedActivity ? '#15803d' : '#0369a1', fontWeight: 600, width: '65%', backgroundColor: '#d1def2' }}>
                          Value
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {allKeys.length > 0 ? (
                        allKeys.map((key) => {
                          const rawOld = olddataObject[key] !== undefined && olddataObject[key] !== null ? olddataObject[key] : '—';
                          const rawNew = newdataObject[key] !== undefined && newdataObject[key] !== null ? newdataObject[key] : '—';
                          const newVal = formatVal(key, rawNew);
                          const isChanged = !isCreatedActivity && String(rawOld) !== String(rawNew);

                          return (
                            <tr
                              key={key}
                              style={{
                                borderBottom: '1px solid #f1f5f9',
                                background: isChanged ? '#fef2f2' : 'transparent',
                                borderLeft: isChanged ? '3px solid #ef4444' : '3px solid transparent',
                                transition: 'background 0.15s ease'
                              }}
                            >
                              <td style={{ padding: '9px 14px', fontWeight: 600, color: isChanged ? '#991b1b' : '#334155' }}>
                                {formatKeyName(key)}
                                {isChanged && (
                                  <span
                                    style={{
                                      marginLeft: '6px',
                                      background: '#fee2e2',
                                      color: '#b91c1c',
                                      fontSize: '10px',
                                      padding: '1px 6px',
                                      borderRadius: '4px',
                                      fontWeight: 700
                                    }}
                                  >
                                    MODIFIED
                                  </span>
                                )}
                              </td>
                              <td style={{ padding: '9px 14px', color: isChanged ? '#991b1b' : '#475569', fontWeight: isChanged ? 700 : 400 }}>
                                {newVal}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="2" style={{ padding: '24px', textAlign: 'center', color: '#94a3b8' }}>
                            No updated version record data available.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        <div
          style={{
            padding: '14px 24px',
            borderTop: '1px solid #e2e8f0',
            background: '#f8fafc',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center'
          }}
        >
          <button
            onClick={onClose}
            style={{
              background: '#64748b',
              color: '#ffffff',
              border: 'none',
              padding: '8px 20px',
              borderRadius: '8px',
              fontWeight: 600,
              fontSize: '13px',
              cursor: 'pointer',
              boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
              transition: 'all 0.15s ease-in-out'
            }}
            onMouseOver={(e) => e.currentTarget.style.background = '#475569'}
            onMouseOut={(e) => e.currentTarget.style.background = '#64748b'}
          >
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
};

const customModalStyles = {
  overlay: {
    backgroundColor: 'rgba(15, 23, 42, 0.65)',
    backdropFilter: 'blur(6px)',
    zIndex: 1300,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px'
  },
  content: {
    position: 'relative',
    top: 'auto',
    left: 'auto',
    right: 'auto',
    bottom: 'auto',
    width: '1180px',
    maxWidth: '95vw',
    maxHeight: '88vh',
    padding: 0,
    border: '1px solid rgba(226, 232, 240, 0.8)',
    borderRadius: '16px',
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.35)',
    overflow: 'hidden',
    inset: 'auto'
  }
};

export default AuditLogChangeView;